import styled from "styled-components";

const Section = styled.section`
  margin: 0 auto;

  @media screen and (max-width: 960px) {
    width: 100%;
    margin-bottom: 120px;
  }
  @media screen and (min-width: 961px) {
    width: 960px;
  }
  @media screen and (min-width: 1281px) {
    width: 1000px;
  }
`;
export default Section;
